interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= total; i += 1) {
    if (i === 1 || i === total || Math.abs(i - current) <= 1) {
      pages.push(i);
    }
  }

  const rendered: (number | string)[] = [];
  pages.forEach((p, index) => {
    if (index > 0 && p - pages[index - 1] > 1) {
      rendered.push(`gap-${p}`);
    }
    rendered.push(p);
  });

  const btnBase =
    'flex h-9 min-w-9 items-center justify-center rounded-md px-3 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap';

  return (
    <nav className="mt-8 flex flex-wrap items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        disabled={current <= 1}
        onClick={() => onChange(current - 1)}
        className={`${btnBase} border border-background-300 text-foreground-700 disabled:cursor-not-allowed disabled:opacity-40 hover:enabled:border-primary-400 hover:enabled:text-primary-700`}
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
      </button>
      {rendered.map((item) =>
        typeof item === 'number' ? (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            className={`${btnBase} ${
              item === current
                ? 'bg-primary-500 text-background-50'
                : 'border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-700'
            }`}
          >
            {item}
          </button>
        ) : (
          <span key={item} className="px-1 text-foreground-400">
            …
          </span>
        ),
      )}
      <button
        type="button"
        disabled={current >= total}
        onClick={() => onChange(current + 1)}
        className={`${btnBase} border border-background-300 text-foreground-700 disabled:cursor-not-allowed disabled:opacity-40 hover:enabled:border-primary-400 hover:enabled:text-primary-700`}
      >
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>
    </nav>
  );
}